import React from 'react';
import { Badge } from '.';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';
import s from './badge-tooltip.module.scss';
import badgeStyles from './wix-choice-badge.module.scss';

interface WixChoiceBadgeProps {
  // Accepted for API compatibility with the other badges, but Wix Choice is
  // outlined so it relies on its own light-blue stroke and ignores the ring.
  showBorder?: boolean;
  size?: 'tiny' | 'small' | 'medium';
}

export function WixChoiceBadge({ size = 'tiny' }: WixChoiceBadgeProps) {
  const { t } = useEssentials();

  return (
    <Badge
      skin="standard"
      type="outlined"
      dataHook="wix-choice-badge"
      uppercase={false}
      size={size}
      tooltipContent={
        <Box direction="vertical" gap="6px">
          <Text
            size="small"
            weight="bold"
            // @ts-expect-error wds types are incompatible
            skin="light"
            className={s.tooltipText}
          >
            {t('wix.choice.badge')}
          </Text>
          <Text
            size="small"
            weight="thin"
            // @ts-expect-error wds types are incompatible
            skin="light"
            className={s.tooltipText}
          >
            {t('wix.choice.badge.tooltip')}
          </Text>
        </Box>
      }
    >
      <Box
        fontSize={size === 'medium' ? 'small' : 'tiny'}
        className={badgeStyles.wixChoiceText}
      >
        {t('wix.choice.badge')}
      </Box>
    </Badge>
  );
}
